export default "__VITE_ASSET__ae73026a__"